// extracted by mini-css-extract-plugin
export default {"fieldError":"style_fieldError__2FoAJ","textError":"style_textError__lRtA7","detailsInput":"style_detailsInput__gVTTg"};